import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { BildirimService, IBildirim, IBildirimGrubu } from '@/src/app/servisler/bildirim.service';
import { PushService } from '@/src/app/servisler/push.service';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'bildirim-dropdown',
  standalone: true,
  imports: [RouterModule, FormsModule, NzBadgeModule, NzButtonModule, NzIconModule, NzPopoverModule, NzSpinModule, NzSwitchModule, NzTooltipModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="bd-wrapper">
      <button nz-button nzType="text" nzShape="circle" class="bd-bell"
              nz-popover [nzPopoverContent]="bildirimPanelTpl" nzPopoverTrigger="click"
              nzPopoverPlacement="bottomRight" [nzPopoverOverlayClassName]="'bd-popover'"
              (nzPopoverVisibleChange)="popoverDegisti($event)">
        <nz-badge [nzCount]="bildirimSvc.okunmamisSayisi()" nzSize="small" [nzOverflowCount]="99"
                  [nzStyle]="badgeStil">
          <nz-icon nzType="bell" nzTheme="outline" />
        </nz-badge>
      </button>
    </div>

    <ng-template #bildirimPanelTpl>
      <div class="bd-panel">
        <div class="bd-baslik">
          <span class="bd-baslik-yazi">Bildirimler</span>
          <div class="bd-baslik-aksiyonlar">
            @if (pushSvc.destekleniyor()) {
              <nz-switch nzSize="small" [ngModel]="pushSvc.abone()" (ngModelChange)="pushToggle($event)"
                         nz-tooltip [nzTooltipTitle]="pushSvc.abone() ? 'Push kapal\u0131' : 'Push a\u00E7'" class="bd-push-switch"></nz-switch>
            }
            @if (bildirimSvc.okunmamisSayisi() > 0) {
              <button nz-button nzSize="small" nzType="link" (click)="bildirimSvc.tumunuOkunduYap()"
                      nz-tooltip nzTooltipTitle="T\u00FCm\u00FCn\u00FC okundu yap">
                <nz-icon nzType="check-circle" nzTheme="outline" />
              </button>
            }
          </div>
        </div>
        <div class="bd-liste">
          @if (bildirimSvc.yukleniyor()) {
            <div class="bd-yukle"><nz-spin nzSimple nzSize="small"></nz-spin></div>
          } @else if (bildirimSvc.grupluBildirimler().length === 0) {
            <div class="bd-bos">
              <nz-icon nzType="bell" nzTheme="outline" class="bd-bos-ikon" />
              <span>Bildirim yok</span>
            </div>
          } @else {
            @for (grup of bildirimSvc.grupluBildirimler().slice(0, gosterilenSayi); track grup.kartId) {
              @if (grup.toplam === 1) {
                <div class="bd-oge" [class.bd-oge--okunmamis]="!grup.sonBildirim.okudu"
                     [class.bd-oge--acil]="grup.sonBildirim.oncelik === 'acil'"
                     (click)="bildirimTiklandi(grup.sonBildirim)">
                  <div class="bd-oge-avatar" [style.background]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).renk + '18'">
                    @if (grup.sonBildirim.gondericIsim) {
                      <span class="bd-oge-harf" [style.color]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).renk">{{ bildirimSvc.gondericBasHarfleri(grup.sonBildirim.gondericIsim) }}</span>
                    } @else {
                      <nz-icon [nzType]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).ikon" nzTheme="outline"
                               [style.color]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).renk" />
                    }
                  </div>
                  <div class="bd-oge-icerik">
                    @if (grup.sonBildirim.gondericIsim) {
                      <span class="bd-oge-gonderici">{{ grup.sonBildirim.gondericIsim }}</span>
                    }
                    <div class="bd-oge-mesaj">{{ grup.sonBildirim.mesaj }}</div>
                    @if (grup.sonBildirim.kartBaslik) {
                      <div class="bd-oge-kart">
                        <nz-icon [nzType]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).ikon" nzTheme="outline" class="bd-oge-kart-ikon" />
                        {{ grup.sonBildirim.kartBaslik }}
                      </div>
                    }
                    <div class="bd-oge-zaman">
                      {{ zamanOnce(grup.sonBildirim.tarih) }}
                      @if (grup.sonBildirim.okudu && grup.sonBildirim.okunduTarih) {
                        <span class="bd-okundu-makbuz" [title]="'Okundu: ' + zamanOnce(grup.sonBildirim.okunduTarih)">&#10003;&#10003;</span>
                      }
                    </div>
                  </div>
                  @if (!grup.sonBildirim.okudu) { <div class="bd-oge-dot"></div> }
                </div>
              } @else {
                <div class="bd-oge bd-oge--grup" [class.bd-oge--okunmamis]="grup.okunmamis > 0"
                     [class.bd-oge--acil]="grup.sonBildirim.oncelik === 'acil'"
                     (click)="grupTiklandi(grup)">
                  <div class="bd-oge-avatar" [style.background]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).renk + '18'">
                    @if (grup.sonBildirim.gondericIsim) {
                      <span class="bd-oge-harf" [style.color]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).renk">{{ bildirimSvc.gondericBasHarfleri(grup.sonBildirim.gondericIsim) }}</span>
                    } @else {
                      <nz-icon [nzType]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).ikon" nzTheme="outline"
                               [style.color]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).renk" />
                    }
                  </div>
                  <div class="bd-oge-icerik">
                    <span class="bd-oge-gonderici">{{ grupOzeti(grup) }}</span>
                    @if (grup.kartBaslik) {
                      <div class="bd-oge-kart">
                        <nz-icon [nzType]="bildirimSvc.olayTipBilgi(grup.sonBildirim.olay).ikon" nzTheme="outline" class="bd-oge-kart-ikon" />
                        {{ grup.kartBaslik }}
                      </div>
                    }
                    <div class="bd-oge-zaman">{{ zamanOnce(grup.sonBildirim.tarih) }}</div>
                  </div>
                  <div class="bd-grup-sayi">{{ grup.toplam }}</div>
                  @if (grup.okunmamis > 0) { <div class="bd-oge-dot"></div> }
                </div>
              }
            }
            @if (bildirimSvc.grupluBildirimler().length > gosterilenSayi) {
              <button nz-button nzType="link" nzBlock class="bd-daha-fazla" (click)="dahaFazlaGoster($event)">
                Daha fazla göster ({{ bildirimSvc.grupluBildirimler().length - gosterilenSayi }})
              </button>
            }
          }
        </div>
        <div class="bd-alt">
          <a [routerLink]="['/\u{1F3E0}/\u{1F468}/\u{1F6A8}']" class="bd-tumunu-gor">
            T\u00FCm\u00FCn\u00FC G\u00F6r
            @if (bildirimSvc.okunmamisSayisi() > 0) {
              <nz-badge [nzCount]="bildirimSvc.okunmamisSayisi()" nzSize="small" [nzOverflowCount]="99"
                        [nzStyle]="{'background-color': '#1890ff', 'font-size': '10px', 'height': '16px', 'line-height': '16px', 'min-width': '16px', 'padding': '0 4px'}" />
            }
          </a>
        </div>
      </div>
    </ng-template>
  `,
  styles: [`
    .bd-bell { position: relative; }
    .bd-panel { width: 380px; max-height: 480px; display: flex; flex-direction: column; }
    .bd-baslik { display: flex; justify-content: space-between; align-items: center; padding: 14px 16px 10px; }
    .bd-baslik-yazi { font-size: 15px; font-weight: 600; }
    .bd-baslik-aksiyonlar { display: flex; gap: 4px; }
    .bd-liste { flex: 1; overflow-y: auto; max-height: 360px; }
    .bd-liste::-webkit-scrollbar { width: 4px; }
    .bd-liste::-webkit-scrollbar-thumb { background: rgba(0,0,0,.12); border-radius: 4px; }

    .bd-oge {
      display: flex; gap: 10px; padding: 10px 16px; cursor: pointer;
      transition: background .15s ease; position: relative;
    }
    .bd-oge:hover { background: var(--py-arkaplan-hover, rgba(0,0,0,.04)); }
    .bd-oge--okunmamis { background: rgba(24,144,255,.03); }
    .bd-oge--okunmamis:hover { background: rgba(24,144,255,.07); }
    .bd-oge--acil { border-left: 3px solid #ff4d4f; }
    .bd-oge--acil .bd-oge-gonderici { color: #ff4d4f; }

    .bd-oge-avatar {
      flex-shrink: 0; width: 36px; height: 36px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      font-size: 14px; font-weight: 600; transition: transform .15s ease;
    }
    .bd-oge:hover .bd-oge-avatar { transform: scale(1.05); }
    .bd-oge-harf { font-size: 13px; font-weight: 700; }

    .bd-oge-icerik { flex: 1; min-width: 0; }
    .bd-oge-gonderici { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); }
    .bd-oge-mesaj { font-size: 12px; color: var(--py-metin-ikincil, #666); line-height: 1.4; margin-top: 1px; }
    .bd-oge-kart {
      font-size: 11px; color: var(--py-metin-ikincil, #888); margin-top: 3px;
      display: flex; align-items: center; gap: 4px;
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .bd-oge-kart-ikon { font-size: 10px; opacity: .6; }
    .bd-oge-zaman { font-size: 11px; color: var(--py-metin-ucuncul, #aaa); margin-top: 3px; display: flex; align-items: center; gap: 4px; }
    .bd-okundu-makbuz { font-size: 10px; color: #1890ff; letter-spacing: -2px; font-weight: 600; }

    .bd-oge-dot {
      width: 8px; height: 8px; border-radius: 50%; background: #1890ff;
      flex-shrink: 0; margin-top: 6px;
      animation: bd-dot-pulse 2s ease-in-out infinite;
    }
    @keyframes bd-dot-pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: .5; }
    }

    .bd-grup-sayi {
      flex-shrink: 0; min-width: 20px; height: 20px; border-radius: 10px;
      background: var(--py-metin-ikincil, #999); color: #fff;
      font-size: 11px; font-weight: 600; display: flex; align-items: center; justify-content: center;
      padding: 0 5px; margin-top: 4px;
    }

    .bd-bos {
      text-align: center; padding: 40px 16px; color: var(--py-metin-ikincil, #999);
      font-size: 13px; display: flex; flex-direction: column; align-items: center; gap: 8px;
    }
    .bd-bos-ikon { font-size: 32px; opacity: .3; }
    .bd-yukle { text-align: center; padding: 24px; }
    .bd-alt {
      padding: 10px 16px; border-top: 1px solid var(--py-kenarlik, #f0f0f0);
      text-align: center;
    }
    .bd-tumunu-gor {
      font-size: 13px; font-weight: 500; display: inline-flex;
      align-items: center; gap: 6px;
    }
    .bd-push-switch { margin-right: 4px; }
    .bd-daha-fazla { font-size: 12px; margin: 4px 0; }
  `],
})
export class BildirimDropdownComponent extends FikoYTKokBilesenComponent {
  bildirimSvc = inject(BildirimService);
  pushSvc = inject(PushService);

  badgeStil = { 'box-shadow': '0 0 0 2px var(--py-arkaplan, #fff)' };
  gosterilenSayi = 15;

  constructor() { super(); }

  dahaFazlaGoster(e: Event) {
    e.stopPropagation();
    this.gosterilenSayi += 15;
    this.CD.detectChanges();
  }

  async pushToggle(acik: boolean) {
    if (acik) {
      const basarili = await this.pushSvc.aboneOl();
      if (!basarili) this.nzMessage.warning('Push bildirimi etkinle\u015Ftirilemedi');
    } else {
      await this.pushSvc.abonelikIptal();
    }
  }

  popoverDegisti(gorunur: boolean) {
    if (gorunur) {
      this.bildirimSvc.bildirimleriYukle();
      this.bildirimSvc.sonGorulmeKaydet();
      this.bildirimSvc.browserBildirimIzniIste();
    }
  }

  zamanOnce(tarih: string): string {
    return BildirimService.zamanOnce(tarih);
  }

  grupOzeti(grup: IBildirimGrubu): string {
    const isim = grup.sonBildirim.gondericIsim || 'Birisi';
    return `${isim} ${grup.toplam} güncelleme yaptı`;
  }

  bildirimTiklandi(b: IBildirim) {
    if (!b.okudu) this.bildirimSvc.okunduIsaretle(b._id!);
    if (b.kartId) {
      this.router.navigate(['/\u{1F3E0}/\u{1F468}/\u{1F6A8}']);
    }
  }

  grupTiklandi(grup: IBildirimGrubu) {
    for (const b of grup.bildirimler) {
      if (!b.okudu) this.bildirimSvc.okunduIsaretle(b._id!);
    }
    if (grup.kartId) {
      this.router.navigate(['/\u{1F3E0}/\u{1F468}/\u{1F6A8}']);
    }
  }
}
